import template from './settings.html';
import controller from './settings.controller';

let settingsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default settingsComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/settings/settings.component.js